<template>
  <el-menu
    :default-active="activeTab"
    class="navbar"
    mode="horizontal"
    @select="handleTabChange"
    :text-color="textColor"
    :active-text-color="activeTextColor"
  >
    <el-menu-item v-for="tab in navTabs" :key="tab.value" :index="tab.value">
      {{ $t(tab.label) }}
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    // 当前激活的 Tab
    activeTab: {
      type: String,
      default: "all",
    },
    // Tab 数据（父组件传过来，不传则用默认国际化key）
    tabs: {
      type: Array,
      default: null,
    },
    // 未激活时的文本颜色
    textColor: {
      type: String,
      default: "#000",
    },
    // 激活时的文本颜色
    activeTextColor: {
      type: String,
      default: "#409EFF",
    },
  },
  computed: {
    // 内部使用国际化导航项
    navTabs() {
      // 如果父组件传了 tabs，直接用父组件的
      if (this.tabs && this.tabs.length) return this.tabs;

      // 默认使用国际化 key
      return [
        { label: "allInfo", value: "all" },
        { label: "underReview", value: "1" },
        { label: "approved", value: "2" },
        { label: "rejected", value: "3" },
      ];
    },
  },
  methods: {
    // 处理 Tab 切换
    handleTabChange(tabValue) {
      this.$emit("tab-change", tabValue);
    },
  },
};
</script>

<style scoped>
.navbar {
  border-bottom: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .el-menu {
    font-size: 14px;
  }

  .el-menu-item {
    padding: 0 10px;
  }
}
</style>
